export const preCacheHook = (data: Record<string, unknown> | null | undefined): Record<string, unknown> | undefined => {
  if (!data) return undefined

  const userData = { ...data }
  if (data.ancestralCountries) {
    userData.ancestry = data.ancestralCountries
    delete userData.ancestralCountries
  }
  return userData
}
